import { render, staticRenderFns } from "./DerbyCity.vue?vue&type=template&id=af956c5a&scoped=true&"
import script from "./DerbyCity.vue?vue&type=script&lang=js&"
export * from "./DerbyCity.vue?vue&type=script&lang=js&"
import style0 from "./DerbyCity.vue?vue&type=style&index=0&id=af956c5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af956c5a",
  null
  
)

export default component.exports